import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPopupStateChanged, setPopupStateDiff } from '#action/project/devices-popup';
import { getSymmetricDifference } from '#component/device/devices-popup/helper';

export const useDevicePopupChangesProject = (formDataObj, openedFromForm) => {
  const dispatch = useDispatch();
  const formDevices = formDataObj?.formDevices;
  const formValues = formDataObj?.initialFormDevices;

  useEffect(() => {
    if (!openedFromForm || !formDevices?.length || !formValues?.length) {
      return;
    }
    const symmetricDiff = getSymmetricDifference(formDevices, formValues) ?? [];
    const isChanged = Boolean(symmetricDiff.length);

    dispatch(setPopupStateChanged(isChanged));
    dispatch(setPopupStateDiff(symmetricDiff));
  }, [dispatch, formDevices, formValues, openedFromForm]);
};
